import React from 'react';
import { Button, Divider, Typography } from '@mui/material';

import Screen from '../Screen';

const PhoneExists = ({ onBack }) => (
  <Screen
    header="An account with the phone number provided already exists."
    subheader="For security purposes, each phone number can only be linked to one account."
  >
    <Button onClick={onBack}>Back</Button>
    <Divider />
    <Typography variant="body2">
      Contact Customer Support if you need help accessing your account.
    </Typography>
    <Button
      variant="text"
      size="medium"
      href="tel:+18558085861"
    >
      (855) 808-5861
    </Button>
  </Screen>
);

export default PhoneExists;
